import { getUserPermission } from "../Storage/Datastore";

export const checkPermission = (permission) => {
  const userPermissions = getUserPermission();
  const isShow = userPermissions?.includes(permission);
  return isShow;
};

export const getUserRoles = (role) => {
  switch (role) {
    case "MEDICAL_OPS_HEAD":
      return "OPERATIONS";
    case "INSURANCE_HEAD":
      return "INSURANCE";
    case "FINANCE_MANAGER":
      return "FINANCE";
    default:
      break;
  }
};
